import { Grid } from './Grid';
import { MergeEngine } from './MergeEngine';

/**
 * Detects cascade chain opportunities: after a merge, checks if the result
 * has any 8-directional neighbor that can merge with it.
 */
export class ChainEngine {
  private grid: Grid;
  private mergeEngine: MergeEngine;

  constructor(grid: Grid, mergeEngine: MergeEngine) {
    this.grid = grid;
    this.mergeEngine = mergeEngine;
  }

  /**
   * Find the first adjacent element that can merge with the element at (col, row).
   * Checks 8 directions clockwise: N, NE, E, SE, S, SW, W, NW.
   * Returns null if no cascade is possible.
   */
  findCascadeTarget(col: number, row: number): { col: number; row: number } | null {
    const element = this.grid.get(col, row);
    if (!element) return null;

    const neighbors = this.grid.getNeighbors8(col, row);
    for (const neighbor of neighbors) {
      if (this.mergeEngine.canMerge(element, neighbor.element)) {
        return { col: neighbor.col, row: neighbor.row };
      }
    }

    return null;
  }
}
